<template>
  <div>
    <section-definition :title="page.title" :report_type_data="report_type_data" :extraOptions="page.options" :icon="page.icon"
      :breadcrumbs="page.breadcrumbs" :exportOptions="page.exportOptions" @report_type="report_types" @openFilter="openPerformanceReportFilter"
      @refreshPage="refreshPerformanceReportPage" :isMaterialIconType="true" @exportData="exportPerformanceReportReport"
      @toggleClick="toggleClick" :style="styleObject"
      >
    </section-definition>
    <loader v-if="page.loading"></loader>
    <v-container v-else fluid grid-list-xl page>
      <v-data-table :headers="getheaders" :items="performance_report" class="elevation-1" :pagination.sync="pagination"
        :total-items="agentperformancetotal" :rows-per-page-items="[5, 10, 25]">
        <template v-slot:items="props" v-if="page.viewing == '1'">
          <td class="checkEmpty p0" v-if="report_type === 'Detailed Report'">{{ props.item.calldate }}</td>
          <td class="checkEmpty p0" v-if="report_type === 'Consolidated Report'">{{ appliedfilter.fromdate +' to '+ appliedfilter.todate }}</td>
          <td class="checkEmpty p0">{{ props.item.agent }}</td>
          <td class="checkEmpty p0">{{ props.item.team }}</td>
          <td class="checkEmpty p0">{{ props.item.login_count }}</td>

          <td class="checkEmpty p0">
            {{
              props.item.answer +
              props.item.unanswer +
              props.item.inbound_unanswer
            }}
          </td>
          <td class="checkEmpty p0">{{ props.item.inbound }}</td>
          <td class="checkEmpty p0">{{ props.item.inbound_unanswer }}</td>
          <td class="checkEmpty p0">{{ props.item.outbound }}</td>
          <td class="checkEmpty p0">{{ props.item.unanswer }}</td>
          <!-- <td class="checkEmpty">{{ props.item.inbound }}</td>
          <td class="checkEmpty">{{ props.item.outbound }}</td>
          <td class="checkEmpty">{{ props.item.preview }}</td>
          <td class="checkEmpty">{{ props.item.dialer }}</td>-->
        </template>
        <template v-slot:items="props" v-else>
          <td class="checkEmpty p0" v-if="report_type === 'Detailed Report'">{{ props.item.calldate }}</td>
          <td class="checkEmpty p0" v-if="report_type === 'Consolidated Report'">{{ appliedfilter.fromdate +' to '+ appliedfilter.todate }}</td>
          <td class="checkEmpty p0">{{ props.item.agent }}</td>
          <td class="checkEmpty p0">{{ props.item.team }}</td>
          <td class="checkEmpty p0">{{ props.item.login_count }}</td>
          <td class="checkEmpty p0">{{ props.item.login }}</td>
          <td class="checkEmpty p0">{{ props.item.billing_break }}</td>
          <td class="checkEmpty p0">{{ props.item.non_billing_break }}</td>
          <td class="checkEmpty p0">{{ props.item.break }}</td>
          <td class="checkEmpty p0">{{ props.item.total_billing_break }}</td>
          <td class="checkEmpty">{{ props.item.wrap }}</td>
          <td class="checkEmpty">{{ props.item.breach }}</td>
          <td class="checkEmpty p0">{{ props.item.talktime }}</td>
          <td class="checkEmpty p0">{{ props.item.idle }}</td>
          <td class="checkEmpty p0">{{ props.item.avg_talk }}</td>
          <td class="checkEmpty p0">{{ props.item.ring }}</td>
          <td class="checkEmpty p0">{{ props.item.handle_time }}</td>
        </template>
      </v-data-table>
    </v-container>
    <!-- <div>
      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="1000">
          <pdfexport
            v-if="dialog"
            :header="pdf.header"
            :pdfdata="pdf_data"
            @closeModel="closeModel"
            title="Performance Report"
          ></pdfexport>
        </v-dialog>
      </v-layout>
    </div> -->
    <v-navigation-drawer fixed disable-resize-watcher right v-model="page.isFilterOpen" class="filterNavigation">
      <v-toolbar small color="secondary" style="color: white">
        <v-toolbar-title>Filter</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon flat color="white" @click="page.isFilterOpen = false">
          <i class="fas fa-close"></i>
        </v-btn>
      </v-toolbar>
      <div
        class="flex-column justify-sb height-100-exclude-toolbar overflow-auto"
      >
        <v-container class="sidenavContainer">
          <div class="row">
            <v-container class="pa-1">
              <v-menu v-model="page.menu.fromdate" :close-on-content-click="false" full-width max-width="290" small>
                <template v-slot:activator="{ on }">
                  <v-text-field :value="appliedfilter.fromdate" label="From Date" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker color="primary" v-model="appliedfilter.fromdate" @change="page.menu.fromdate = false">
                </v-date-picker>
              </v-menu>
            </v-container>

            <v-container class="pa-1">
              <v-menu v-model="page.menu.todate" :close-on-content-click="false" full-width max-width="290" small>
                <template v-slot:activator="{ on }">
                  <v-text-field :value="appliedfilter.todate" label="To Date" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker color="primary" v-model="appliedfilter.todate" @change="page.menu.todate = false">
                </v-date-picker>
              </v-menu>
            </v-container>
          </div>

        <v-autocomplete v-model="appliedfilter.agent" :items="filteragents" label="Agent" persistent-hint small multiple
          single-line :allow-overflow="false"></v-autocomplete>
        </v-container>

        <v-container row class="sidenavFooter">
          <v-btn flat @click="resetvalue()">Reset</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="getDataFrom()">Filter</v-btn>
        </v-container>
      </div>
    </v-navigation-drawer>
  </div>
</template>
<script>
import loader from "@/components/Widgets/loader";
import { mapGetters } from "vuex";
// import pdfexport from "./Components/pdfexport";
import moment from "moment";
export default {
  components: {
    loader,
    // pdfexport,
  },
  mounted() {
    let scope = this;
    this.page.loading = false;
    this.page.loading = false;
    let teams =  JSON.parse(localStorage.getItem("Team"))
    let team_agent_user =  JSON.parse(localStorage.getItem("Team_agent_user"))
    if (teams.length > 0 && team_agent_user.length > 0) {
      this.filteragents = team_agent_user
    }else{
      this.filteragents = JSON.parse(localStorage.getItem("agent_emails"));
    }
    // this.$store.dispatch("reportuserlist").then(() => {
      //   // this.getDataFromApi();
    //   this.dateformate();
    // });
    this.dateformate();
    setTimeout(
      function () {
        if (
          scope.$store.getters.UserPermissions.indexOf(
            "reports:agentperformance:export"
          ) !== -1
        ) {
          scope.page.exportOptions = ["CSV", "Txt(Tab-Delimited)"];
        } else {
          scope.page.exportOptions = [];
        }
      }.bind(scope),
      1
    );
    // this.getDataFromApi();
  },
  computed: {
    getheaders: function () {
      if (this.page.viewing == "1") {
        return this.headers1;
      } else {
        return this.headers2;
      }
    },
    ...mapGetters(["performance_report", "filters"]),
  },
  data() {
    return {
      renderflag:false,
      styleObject: {
        height: "80px",
        "margin-top": "-8px",
      },
      page: {
        title: "Agent Daily Performance Report",
        icon: "network_check",
        loading: true,
        materialicon: true,
        isFilterOpen: false,
        playingRecord: false,
        breadcrumbs: [],
        options: { filter: true, refresh: true, toggleButton: true , tab:['Calls', 'Time'], select_box_report: true},
        exportOptions: [],

        viewing: "1",
        menu: {
          fromdate: false,
          todate: false,
        },
      },
      payload: {
        from_date: "",
        to_date: "",
        skip: 0,
        take: 0,
        agent: "",
        detail: "performance",
        descending: "",
        export: "Performancereport",
      },
      total: "",
      call_date: "",
      report: "",
      exports: [],
      excel_data: [],
      pdf_data: [],
      txt_data: [],
      filteragents: [],
      from_date: "",
      to_date: "",
      dialog: false,
      appliedfilter: {
        fromdate: "",
        todate: "",
        agent: "",
      },
      export_calls: "1",
      pagination: {
        rowsPerPage: 10,
      },
      report_type_data:['Detailed Report','Consolidated Report'],
      report_type:"",
      headers1: [
        {
          text: "Date",
          align: "left",
          sortable: true,
          class: "p0",
          value: "calldate",
        },
        {
          text: "Agent",
          align: "left",
          sortable: false,
          class: "p0",
          value: "agent",
        },
        {
          text: "Team",
          align: "left",
          sortable: false,
          class: "p0",
          value: "team",
        },
        {
          text: "Login Count",
          align: "left",
          sortable: false,
          class: "p0",
          value: "login_count",
        },
        {
          text: "Total Calls",
          align: "left",
          sortable: false,
          class: "p0",
          value: "total",
        },
        {
          text: "Inbound Answer",
          align: "left",
          sortable: false,
          class: "p0",
          value: "inboundanswer",
        },
        {
          text: "Inbound Unanswer",
          align: "left",
          sortable: false,
          class: "p0",
          value: "inboundunanswer",
        },
        {
          text: "Outbound Answer",
          align: "left",
          sortable: false,
          class: "p0",
          value: "outboundanswer",
        },
        {
          text: "Outbound Unanswer",
          align: "left",
          sortable: false,
          class: "p0",
          value: "outboundunanswer",
        },
        // {
        //   text: "Answered",
        //   align: "left",
        //   sortable: false,
        //   class: "p0",
        //   value: "answered",
        // },
        // {
        //   text: "Unanswered",
        //   align: "left",
        //   sortable: false,
        //   class: "p0",
        //   value: "unanswered",
        // },
        // { text: "Inbound", align: "left", sortable: false, value: "inbound" },
        // { text: "Outbound", align: "left", sortable: false, value: "outbound" },
        // { text: "Preview", align: "left", sortable: false, value: "preview" },
        // { text: "Auto", align: "left", sortable: false, value: "dialer" }
      ],
      headers2: [
        {
          text: "Date",
          align: "left",
          sortable: true,
          class: "p0",
          value: "calldate",
        },
        {
          text: "Agent",
          align: "left",
          sortable: false,
          class: "p0",
          value: "agent",
        },
        {
          text: "Team",
          align: "left",
          sortable: false,
          class: "p0",
          value: "team",
        },
        {
          text: "Login Count",
          align: "left",
          sortable: false,
          class: "p0",
          value: "login_count",
        },
        {
          text: "Staff Time",
          align: "left",
          sortable: false,
          class: "p0",
          value: "login",
        },
        {
          text: "Billable break time",
          align: "left",
          sortable: false,
          class: "p0",
          value: "billing_break",
        },
        {
          text: "Non-billable break time",
          align: "left",
          sortable: false,
          class: "p0",
          value: "non_billing_break",
        },
        {
          text: "Total Break Time",
          align: "left",
          sortable: false,
          class: "p0",
          value: "break",
        },
        {
          text: "Total billable time",
          align: "left",
          sortable: false,
          class: "p0",
          value: "total_billing_break",
        },
        {
          text: "Wrap Time",
          align: "left",
          sortable: false,
          class: "p0",
          value: "wrap",
        },
        {
          text: "Breach Time",
          align: "left",
          sortable: false,
          class: "p0",
          value: "breach",
        },
        
        {
          text: "Talk Time",
          align: "left",
          sortable: false,
          class: "p0",
          value: "talktime",
        },
       
        {
          text: "Idle Time",
          align: "left",
          sortable: false,
          class: "p0",
          value: "idle",
        },
        {
          text: "Avg Talk time",
          align: "left",
          sortable: false,
          class: "p0",
          value: "avg",
        },
        {
          text: "Ring time",
          align: "left",
          sortable: false,
          class: "p0",
          value: "ring",
        },
        {
          text: "Handle time",
          align: "left",
          sortable: false,
          class: "p0",
          value: "handle_time",
        },
        
      ],
      agentperformancereport: [],
      agentperformancetotal: 0,
      pdf: {
        header: [
          { text: "Date", align: "left", sortable: true, value: "calldate" },
          { text: "Agent", align: "left", sortable: false, value: "agent" },
          {
            text: "Total Calls",
            align: "left",
            sortable: false,
            value: "total",
          },
          {
            text: "Inbound Answer",
            align: "left",
            sortable: false,
            value: "inboundanswer",
          },
          {
            text: "Inbound Unanswer",
            align: "left",
            sortable: false,
            value: "inboundunanswer",
          },
          {
            text: "Outbound Answer",
            align: "left",
            sortable: false,
            value: "outboundanswer",
          },
          {
            text: "Outbound Unanswer",
            align: "left",
            sortable: false,
            value: "outboundunanswer",
          },
          // {
          //   text: "Answered",
          //   align: "left",
          //   sortable: false,
          //   value: "answered",
          // },
          // {
          //   text: "Unanswered",
          //   align: "left",
          //   sortable: false,
          //   value: "unanswered",
          // },
          {
            text: "Staff Time",
            align: "left",
            sortable: false,
            value: "login",
          },
          {
            text: "Total Break Time",
            align: "left",
            sortable: false,
            value: "break",
          },
          {
            text: "Wrap Time",
            align: "left",
            sortable: false,
            class: "p0",
            value: "wrap",
          },
          {
            text: "Breach Time",
            align: "left",
            sortable: false,
            class: "p0",
            value: "breach",
          },
          {
            text: "Talk Time",
            align: "left",
            sortable: false,
            value: "talktime",
          },
          { text: "Idle Time", align: "left", sortable: false, value: "idle" },
          {
            text: "Avg Talk time",
            align: "left",
            sortable: false,
            value: "avg",
          },
          { text: "Acw Time", align: "left", sortable: false, value: "idle" },
          {
            text: "Avg Acw Time",
            align: "left",
            sortable: false,
            value: "idle",
          },
          {
            text: "Handle Time",
            align: "left",
            sortable: false,
            value: "idle",
          },
          {
            text: "Avg Handle Time",
            align: "left",
            sortable: false,
            value: "idle",
          },

          {
            text: "Ring Time",
            align: "left",
            sortable: false,
            value: "ring",
          },
          {
            text: "First Login Time",
            align: "left",
            sortable: false,
            value: "idle",
          },
          {
            text: "Last Logout Time",
            align: "left",
            sortable: false,
            value: "idle",
          },
        ],
      },
    };
  },
  watch: {
    pagination: {
      handler() {
        console.log(this.pagination,"paginationpagination");
        if(!this.renderflag){
          this.getDataFromApi();
        }else if(this.renderflag == true){
          this.renderflag = false
        }
      },
      deep: true,
    },
    "appliedfilter.fromdate"(newVal) {
      var from_date = moment(newVal).format("YYYY-MM-DD");
      this.$store.commit("ACTION_FROMDATE", from_date);
      this.$store.commit("FILTERFROMDATE", from_date);
      this.skip = 0;
      // this.getDataFromApi();
    },
    "appliedfilter.todate"(newVal) {
      var to_date = moment(newVal).format("YYYY-MM-DD");
      this.$store.commit("ACTION_TODATE", to_date);
      this.$store.commit("FILTER_TODATE", to_date);
      this.skip = 0;
      // this.getDataFromApi();
    },
    "appliedfilter.agent"(newVal) {
      this.$store.commit("FILTER_AGENT", { agent: newVal });
      this.skip = 0;
      // this.getDataFromApi();
    },
  },
  methods: {
    report_types (val, mountflag){
      console.log('this is checking val 1',val)
      this.report_type = val
      if(mountflag == true){
        this.dateformate();
        this.renderflag = true
        this.getDataFromApi();
      }
      if(mountflag === undefined){
        this.resetvalue(false)
      }
    },
    openPerformanceReportFilter: function () {
      this.page.isFilterOpen = true;
    },
    refreshPerformanceReportPage: function () {
      var scope = this;
      scope.dateformate();
      scope.refreshvalue();
      // scope.pagination.page=1
      scope.appliedfilter.agent = "";
      scope.getDataFromApi();

    },
    exportPerformanceReportReport: function (option) {
      if (option == "PDF" || option == "Txt(Tab-Delimited)") {
        this.dialog = true;
      }
      ``;
      //var export_option = {export_formate : option , viewing : this.page.viewing};
      var export_option = { export_formate: option };
      this.export(export_option);
    },
    toggleClick: function (option) {
      this.page.viewing = option;
    },
    dateformate() {
      this.page.loading = false;
      this.to_date = new Date();
      this.to_date = moment(this.to_date).format("YYYY-MM-DD");
      var from_date1 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 30;
      from_date1.setTime(from_date1.getTime() - dateOffset);
      this.from_date = moment(from_date1).format("YYYY-MM-DD");
      this.appliedfilter.fromdate = this.from_date;
      this.appliedfilter.todate = this.to_date;
      this.$store.commit("FILTERFROMDATE", this.from_date);
      this.$store.commit("FILTER_TODATE", this.to_date);
    },
    getDataFromApi() {
      var scope = this;
      var { descending } = scope.pagination;
      scope.payload.to_date = scope.to_date;
      scope.payload.from_date = scope.from_date;
      var { page, rowsPerPage } = scope.pagination;
      //scope.$store
      //  .dispatch("reportuserlist")
      //  .then((response) => {
      //    let dataa = response.toString(",");
      let team_name = ""
      let teams =  JSON.parse(localStorage.getItem("Team"))
      let team_agent_user =  JSON.parse(localStorage.getItem("Team_agent_user"))
      if (teams.length > 0 && team_agent_user.length > 0) {
        scope.payload.agent = team_agent_user
        team_name = teams.map(elm => elm.name).flat()
      }else{
        scope.payload.agent = JSON.parse(localStorage.getItem("agent_emails"));
      }
      if (rowsPerPage == -1) {
        scope.payload.take = scope.total;
      } else if (
        rowsPerPage != "" &&
        rowsPerPage != undefined &&
        rowsPerPage != null
      ) {
        scope.payload.take = rowsPerPage;
      } else {
        scope.payload.take = 5;
      }
      if (page != "" && page != undefined && page != null) {
        scope.skip = page;
      } else {
        scope.skip = 1;
      }
      scope.payload.skip = (scope.skip - 1) * scope.payload.take;
      scope.payload.descending = descending;
      scope.payload.report_type = this.report_type
      scope.payload.team_name = team_name
      scope.$store
        .dispatch("Performancereport", scope.payload)
        .then((response) => {
          scope.page.loading = false;
          scope.total = response.count;
          // if (scope.page_flag) {
          //   scope.pagination.page = 1;
          //   scope.page_flag = false;
          // }
          scope.agentperformancetotal = scope.total;
          if (response.response.status === 401) {
            scope.$store.dispatch("checkingtoken");
          }
        });
      // });
      //})
    },
    getDataFrom() {
      this.skip = 0;
      this.getDataFromApi();
      this.page_flag = true;
      this.page.isFilterOpen=false
    },
    resetvalue(filter = true) {
      this.skip = 0;
      var to_date = new Date();
      to_date = moment(to_date).format("YYYY-MM-DD");
      var from_date = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 30;
      from_date.setTime(from_date.getTime() - dateOffset);
      from_date = moment(from_date).format("YYYY-MM-DD");
      this.$store.dispatch("fromdate", from_date);
      this.$store.dispatch("todate", to_date);
      this.appliedfilter.agent = "";
      this.appliedfilter.flag = true;
      this.appliedfilter.fromdate = "";
      this.appliedfilter.todate = "";
      if (this.appliedfilter.flag) {
        this.appliedfilter.fromdate = from_date;
        this.appliedfilter.todate = to_date;
        this.appliedfilter.flag = false;
      }
      this.$store.commit("FILTER_AGENT", { agent: "" });
      this.getDataFromApi();
      if(filter){
        this.page.isFilterOpen = true;
      }
    },
    closeModel: function () {
      this.dialog = false;
    },

    export(option) {
      this.excel_data = [];
      this.txt_data = [];
      // this.pdf_data = [];
      var from_date = moment(this.payload.from_date).format("YYYY-MM-DD");
      var to_date = moment(this.payload.to_date).format("YYYY-MM-DD");
      let teams =  JSON.parse(localStorage.getItem("Team"))
      // let team_agent_user =  JSON.parse(localStorage.getItem("Team_agent_user"))
      let team_name = ""
      if (teams.length > 0) {
        team_name = teams.map(elm => elm.name).flat()
      }
      var export_date = {
        from_date: from_date,
        to_date: to_date,
        misseddetail: "Performancereport",
        report_type: this.report_type,
        team_name: team_name
      };
      this.exportAgentPerformanceData(option, export_date)
    },


    exportAgentPerformanceData(option, export_date) {
  this.$store.dispatch("exportdatafetch", export_date).then((response) => {
    this.exports = response;
    this.excel_data = [];
    this.txt_data = [];

    // ✅ Header definition
    let headers = [
      "Date", "Agent", "Agent Name", "Team", "Total Calls",
      "Inbound Answer", "Inbound Unanswer", "Outbound Answer", "Outbound Unanswer",
      "Login Count", "Staff Time", 'Billable break time','Non-billable break time', "Total Break Time",'Total billable time', "Talk Time", "Idle Time",
      "Avg Talk Time", "Ring Time", "Acw Time", "Avg Acw Time",
      "Handle Time", "Avg Handle Time","Breach Time"
    ];

    if (this.report_type === 'Detailed Report') {
      headers.push("First Login Time", "Last Logout Time");
    }

    // ✅ Prepare data rows
    response.forEach((record) => {
      const changedate = this.report_type === 'Detailed Report'
        ? record.calldate
        : `${this.appliedfilter.fromdate} to ${this.appliedfilter.todate}`;

      const init_obj = {
        "Date": changedate,
        "Agent": record.agent,
        "Agent Name": record.agent_name,
        "Team": record.team,
        "Total Calls": (record.answer || 0) + (record.unanswer || 0) + (record.inbound_unanswer || 0),
        "Inbound Answer": record.inbound,
        "Inbound Unanswer": record.inbound_unanswer,
        "Outbound Answer": record.outbound,
        "Outbound Unanswer": record.unanswer,
        "Login Count": record.login_count,
        "Staff Time": record.login,
        'Billable break time':record.billing_break||"00:00:00",
        'Non-billable break time':record.non_billing_break||"00:00:00",
        "Total Break Time": record.break || "00:00:00",
        'Total billable time': record.total_billing_break || "00:00:00",
        "Talk Time": record.talktime,
        "Idle Time": record.idle,
        "Avg Talk Time": record.avg_talk,
        "Ring Time": record.ring,
        "Acw Time": record.acw,
        "Avg Acw Time": record.avg_acw,
        "Handle Time": record.handle_time,
        "Avg Handle Time": record.avg_handle_time,
        "Breach Time":record.breach,
        ...(this.report_type === 'Detailed Report' && {
          "First Login Time": record.first_login_time,
          "Last Logout Time": record.last_logout_time,
        }),
      };

      this.excel_data.push(init_obj);
      this.txt_data.push(init_obj);
    });

    const formattedDate = moment(new Date()).format("YYYY-MM-DD hh-mm");
    const fileName = `AgentPerformanceReport${formattedDate}`;

    // ✅ Generate and download file with header
    this.generateFile(option.export_formate, headers, fileName);
  });
},

generateFile(format, headers, fileName) {
  let fileContent = headers.join(format === "CSV" ? "," : "\t") + "\r\n"; // ✅ Add header

  if (format === "CSV") {
    this.excel_data.forEach((row) => {
      const data = headers.map((key) =>
        row[key] !== undefined
          ? String(row[key]).replace(/'|"|#|\n/g, " ").replace(/,/g, ";")
          : ""
      );
      fileContent += data.join(",") + "\r\n";
    });

    const encodedUri = `data:text/csv;charset=utf-8,${encodeURIComponent(fileContent)}`;
    this.downloadFile(encodedUri, `${fileName}.csv`);
  } else if (format === "Txt(Tab-Delimited)") {
    this.txt_data.forEach((row) => {
      const data = headers.map((key) => (row[key] !== undefined ? row[key] : ""));
      fileContent += data.join("\t") + "\r\n";
    });

    const encodedUri = `data:text/plain;charset=utf-8,\uFEFF${encodeURIComponent(fileContent)}`;
    this.downloadFile(encodedUri, `${fileName}.txt`);
  }
},

downloadFile(encodedUri, fileName) {
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link); // Clean up after download
},


    refreshvalue() {
      this.$store.commit("FILTER_AGENT", { agent: "" });
      this.page_flag = true;
    },
  },

  beforeDestroy() {
    this.$store.commit("FILTER_AGENT", { agent: "" });
  },
};
</script>
